module.exports = __webpack_public_path__ + "99735a9d3ead2dce07a719fa79ea38ab.woff2";